import { PillUnit } from '@mark43/cad-api';
import { useCanTransitionToUnitStateGroup } from '../../common/hooks/use-can-transition-to-unit-state-group';
import { ErrorBoundary } from '../../monitoring/error-boundary';
import { ItemsWithSeparators } from '../../context-menus/components/items-with-separators';
import { EditTemporaryUnitItem, EditUnitItem } from './edit-unit-item';
import { ViewOnMapItem } from './view-on-map-item';
import { AssignToEventItem } from './assign-to-event-item';
import { RemoveHoldItem } from './remove-hold-item';
import { useEnabledFeatures } from '../../common/hooks/enabled-features/use-enabled-features';
import { OffDutyItem } from '../../common/components/off-duty-item';

export const HeldUnitContextMenu = ({ data }: { data: PillUnit }): React.ReactElement => {
    const { logOnEditUnit, unitManagement } = useEnabledFeatures();
    const canTransitionToUnitStateGroup = useCanTransitionToUnitStateGroup(data.unitStateId);

    const pillUnit = data;

    const showAssignToEventItem = unitManagement && canTransitionToUnitStateGroup('DISPATCHED');

    const showEditUnitItem = logOnEditUnit && !pillUnit.isTemporary;

    const showEditTemporaryUnitItem = logOnEditUnit && pillUnit.isTemporary;

    const showOffDutyItem = unitManagement;

    const group1Items: React.ReactElement[] = [
        showAssignToEventItem && !!pillUnit.eventId && (
            <AssignToEventItem
                unitId={pillUnit.id}
                agencyEventId={pillUnit.eventId}
                key="assign-to-event"
            />
        ),
        !!pillUnit.eventId && (
            <RemoveHoldItem
                unitId={pillUnit.id}
                agencyEventId={pillUnit.eventId}
                key="remove-hold"
            />
        ),
    ].filter((el) => !!el) as React.ReactElement[];

    const group2Items: React.ReactElement[] = [
        <ViewOnMapItem unitId={pillUnit.id} key="view-on-map" />,
    ].filter((el) => !!el) as React.ReactElement[];

    const group3Items: React.ReactElement[] = [
        showEditUnitItem && <EditUnitItem unitId={pillUnit.id} key="edit-unit" />,
        showEditTemporaryUnitItem && (
            <EditTemporaryUnitItem unitId={pillUnit.id} key="edit-temporary-unit" />
        ),
        showOffDutyItem && (
            <OffDutyItem
                unitId={pillUnit.id}
                unitStateId={pillUnit.unitStateId}
                isAssignedToEvent={pillUnit.isAssignedToAnotherEvent}
                key="off-duty"
            />
        ),
    ].filter((el) => !!el) as React.ReactElement[];

    return (
        <ErrorBoundary
            name="HELD_UNIT_CONTEXT_MENU"
            messageVerbNoun="opening the held unit menu"
            asToast={true}
        >
            <ItemsWithSeparators itemGroups={[group1Items, group2Items, group3Items]} />
        </ErrorBoundary>
    );
};
